import React, { FC, useState } from "react";
import CustomAccordion from "../../common/CustomAccordion";
import GeneralTabs from "../../common/GeneralTabs";
import PaperWiseMarksDistribution from "../PaperWiseMarksDistribution";
import {
  ExampaperdetailTypes,
  ExamsDetailsTypes,
  IExamResultTypeWrapper,
  MarksDetails,
} from "../../../interfaces/exams.interface";
import ApproveScrutinyModal from "./ApproveScrutinyModal";

type AnswerSectionForScrtinyProps = {
  userResult: IExamResultTypeWrapper;
  selectedPaper: number;
  setSelectedPaper: React.Dispatch<React.SetStateAction<number>>;
  selectedPaperDetails: ExampaperdetailTypes | null;
  examsDetailsTypes?: ExamsDetailsTypes | null;
  handleClose: any;
  refreshList?: () => void;
  onlyAnswerKeys?:boolean;
};
const AnswerSectionForScrtiny: FC<AnswerSectionForScrtinyProps> = ({
  userResult,
  selectedPaper,
  setSelectedPaper,
  examsDetailsTypes,
  selectedPaperDetails,
  handleClose,
  refreshList,
  onlyAnswerKeys
}) => {
  const [selectedAnswer, setSelectedAnswer] = useState<any>(null);
  const [openApplyScrutiny, setOpenApplyScrutiny] = useState<boolean>(false);
  return (
    <div className="mt-3 w-full mx-auto ">
      <ApproveScrutinyModal
        refreshList={refreshList}
        setSelectedAnswer={setSelectedAnswer}
        handleCloseParent={handleClose}
        examsDetailsTypes={examsDetailsTypes}
        selectedAnswer={selectedAnswer}
        selectedPaperDetails={selectedPaperDetails}
        isOpen={openApplyScrutiny}
        handleClose={() => setOpenApplyScrutiny(false)}
        examStatus={userResult?.exam_paper_details?.[0]?.status}
      />
      <CustomAccordion title="Your Selected Answers" noArrow primary>
        {!!userResult ? (
          <>
            <div className=" mt-2">
              {examsDetailsTypes ? (
                <div className="w-full  " key={Math.random()}>
                  <div className="pl-1 lg:pl-3 text-gray-500 font-semibold text-sm lg:text-xl w-full border-l border-r ">
                    # Paper Information
                  </div>
                  <div className=" grid grid-cols-12 gap-y-2 py-2 border-l border-r px-3 pb-3 mb-2 rounded-b-md border-b border-gray-300 ">
                    <div className="lg:col-span-7 col-span-12">
                      <div className=" text-sm font-semibold ">
                        Exam Paper Name
                      </div>
                      <div className=" font-semibold text-xl">
                        {userResult?.exam_paper_details?.[0]?.title}
                        {/* {selectedPaperDetails.title} */}
                        {/* {examsDetailsTypes?.title} */}
                      </div>
                    </div>
                    <div className="col-span-5">
                      <div className=" font-semibold text-sm ">
                        Total Question
                      </div>
                      <div className="font-semibold text-xl ">
                        {userResult?.exam_paper_details?.[0]?.total_questions}
                      </div>
                    </div>
                    <div className="col-span-7 ml-5 lg:ml-0">
                      <div className=" font-semibold text-sm ">Total Marks</div>
                      <div className="font-semibold text-xl ">
                        {userResult?.exam_paper_details?.[0]?.total_marks}
                      </div>
                    </div>
                    {userResult?.exam_paper_details?.[0]?.obtain_marks ? (
                      <div className="lg:col-span-5 col-span-12">
                        <div className=" font-semibold text-sm ">
                          Obtained Marks
                        </div>
                        <div className="font-semibold text-xl ">
                          {userResult?.exam_paper_details?.[0]?.obtain_marks}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    {userResult?.exam_paper_details?.[0]?.total_correct ? (
                      <div className="lg:col-span-7 col-span-12">
                        <div className=" font-semibold text-sm ">
                          Total Correct Answer
                        </div>
                        <div className="font-semibold text-xl ">
                          {userResult?.exam_paper_details?.[0]?.total_correct}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    {userResult?.exam_paper_details?.[0]?.total_incorrect ? (
                      <div className="lg:col-span-5 col-span-12">
                        <div className=" font-semibold text-sm ">
                          Total Incorrect Answer
                        </div>
                        <div className="font-semibold text-xl ">
                          {userResult?.exam_paper_details?.[0]?.total_incorrect}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div className="pb-12">
              <div className="py-1 text-xl font-semibold pl-3 text-gray-500 mb-2">
                {onlyAnswerKeys ? `# Your Answers`:`# Choose Answer For Objection `}
              </div>
              {userResult?.exam_paper_details?.[0] &&
                userResult?.exam_paper_details?.[0]?.details?.map(
                  (item: any, dIndex: number) => (
                    <PaperWiseMarksDistribution
                      item={item}
                      setSelectedAnswer={setSelectedAnswer}
                      key={dIndex}
                      qIndex={dIndex}
                      selectedAnswer={selectedAnswer}
                      examsDetailsTypes={examsDetailsTypes}
                      examStatus={userResult?.exam_paper_details?.[0]?.status}
                      onlyAnswerKeys={onlyAnswerKeys}
                    />
                  )
                )}
            </div>
            {selectedAnswer ? (
              <div className="fixed  py-4 bottom-0 left-0 w-screen bg-gray-200  flex justify-center lg:justify-end items-center pr-5">
                <button
                  onClick={() => setOpenApplyScrutiny(true)}
                  className="animate-pulse cta-button bg-[#3b82f6]  px-5 py-2 rounded-sm hover:-translate-y-1 hover:-translate-x-1 transition-all ease-in-out duration-300 text-white"
                >
                  Apply For Objection
                </button>
              </div>
            ) : (
              <></>
            )}
          </>
        ) : (
          // </GeneralTabs>
          <></>
        )}
      </CustomAccordion>
    </div>
  );
};

export default AnswerSectionForScrtiny;
